import { render, staticRenderFns } from "./ClientNotificationsSetup.vue?vue&type=template&id=3f3cda3b&scoped=true&"
import script from "./ClientNotificationsSetup.vue?vue&type=script&lang=js&"
export * from "./ClientNotificationsSetup.vue?vue&type=script&lang=js&"
import style0 from "./ClientNotificationsSetup.vue?vue&type=style&index=0&id=3f3cda3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3cda3b",
  null
  
)

export default component.exports